import { Slider, SliderProps } from "@mui/material";

type CoreSliderProps = Omit<SliderProps, "aria-label" | "aria-labelledby" | "onChange" | "value"> & {
	thumbShape: "rectangle" | "circle";
	value: number;
	onChange: (value: number) => void;
	trackFilledColor?: string;
	trackUnfilledColor?: string;
	thumbColor?: string;

	/**For Accessibility */
	ariaLabel?: string;
	ariaLabelledBy?: string;
};

export default function CoreSlider({
	thumbShape,
	trackFilledColor = "#432A6F",
	trackUnfilledColor = "#E1DCE9",
	thumbColor = "#7E65A5",
	ariaLabel,
	ariaLabelledBy,
	onChange,
	value,
	...props
}: CoreSliderProps) {
	return (
		<Slider
			aria-label={ariaLabel}
			aria-labelledby={ariaLabelledBy}
			sx={{
				height: "10px",
				width: "100%",
				"& .MuiSlider-track": {
					backgroundColor: trackFilledColor,
					border: "none",
				},

				"& .MuiSlider-rail": {
					backgroundColor: trackUnfilledColor,
					opacity: 1,
				},
				"& .MuiSlider-thumb": {
					backgroundColor: thumbColor,

					height: thumbShape === "rectangle" ? "20px" : "24px",
					width: thumbShape === "rectangle" ? "12px" : "24px",
					borderRadius: thumbShape === "rectangle" ? "2px" : "50%",
				},
				...props.sx,
			}}
			// Slider supports multiple thumbs -> for now CoreSlider handles one thumb -> perhaps in the future?
			onChange={(_e, value) => onChange(typeof value === "number" ? value : value[0])}
			value={value}
			{...props}
		/>
	);
}
